export default function(name) {

	this.save = async function(o) {
		localStorage.setItem(name, JSON.stringify(o));
		return Promise.resolve();
	}; // save()

	this.get = async function() {
		var o = JSON.parse(localStorage.getItem(name)) || null;
		return Promise.resolve(o);
	}; // get()

};
